import { makeStyles } from '@material-ui/core/styles'

const headerStyles = makeStyles(theme => ({
  headerBar: {
    height: 'auto',
    background: '#F37320',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 20px',
    flexWrap: 'wrap',
    justifyContent: 'space-between',

    '@media (max-width: 767px)': {
      alignItems: 'flex-start',
    }
  },
  logoDiv: {
    display: 'flex',
    color: '#FFF',
    fontSize: '14px',
    fontWeight: 'bold',
    alignItems: 'center',
    minWidth: '170px',

    '@media (max-width: 768px)': {
      minWidth: '150px'
    }
  },
  logoImage: {
    width: '28px',
    height: '28px',
    margin: '10px'
  },
  title: {
    fontFamily: 'sans-serif'
  },
  navWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    //width: '600px',

    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'baseline',
      marginTop: '10px',
      marginLeft: '10px'
    },
    '@media (max-width: 1024px)': {
      // width: '45%',
    },
  },
  nav: {
    color: '#ffffff',
    fontFamily: 'sans-serif',
    textTransform: 'capitalize',
    cursor: 'pointer',
    textDecoration: 'none',
    fontWeight: 'light',
    margin: '0 13px'
  },
  navmd: {
    color: '#000000DE',
    textTransform: 'capitalize',
    cursor: 'pointer',
    textDecoration: 'none',
    fontWeight: 'light'
  },
  avatarContainer: {
    flex: 'auto',
  },
  avatar: {
    backgroundColor: '#F37320 !important',
    float: 'right',
    border: '1px solid white',
    marginRight: '5px',
    cursor: 'pointer'
  },
  avatarIcon: {
    float: 'right',
    color: 'white',
    marginTop: '0.5rem',
    cursor: 'pointer'
  },
  typography: {
    padding: theme.spacing(0.75),
    cursor: 'pointer',
    fontSize: '14px'
  },

  menuButton: {
    color: 'white',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  drawerPaper: {
    width: 280,
  },
  m4: {
    margin: '0 0 0 20px'
  },
  drawerLogoDiv: {
    display: 'flex',
    color: '#FFF',
    fontSize: '14px',
    fontWeight: 'bold',
    alignItems: 'center',
  },
  active: {
    backgroundColor: '#ffe7d7'
  },
  avatarData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '18px',
    color: '#545456',
    padding: '5px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  popoverName: {
    fontSize: '14px',
    color: '#6F6F6F'
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#000000DE'
  },
  headerPaper: {
    minWidth: 200,
    maxWidth: 300,
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
}))

export { headerStyles }